export default __webpack_public_path__ + "static/media/loc-note.7fb171a2.webp";